/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('offersPanelCategory', {
    templateUrl: 'app/components/offers/panel/category/Category.html',
    controller: PanelCategory,
    bindings: {
      roomGroupCategoryFilterId: '<',
      categoryId: '<',
      onClick: '&'
    }
  });

function PanelCategory(PanelObserver, Categories, RoomGroupCategoryFilters, $translate) {
  var $this = this;
  $this.PanelObserver = PanelObserver;
  $this.isOpen = false;
  $this.language = $translate.use();
  $this.roomGroupCategoryFilters = RoomGroupCategoryFilters.getRoomGroupCategoryFilters();
  $this.categories = Categories.getCategories();
}

PanelCategory.prototype = {
  $onInit: function () {
    if (!angular.isArray(this.roomGroupCategoryFilters)) {
      this.roomGroupCategoryFilters = [];
    }
    if (!angular.isArray(this.categories)) {
      this.categories = [];
    }
    this.roomGroupCategoryFilter = this.findRoomGroupCategoryFilterById(this.roomGroupCategoryFilterId);
    this.PanelObserver.setRoomGroupCategoryFilterId(this.roomGroupCategoryFilter.id);

    this.category = this.findCategoryById(this.categoryId);
    this.PanelObserver.setCategoryId(this.category.id);
  },

  $onChanges: function () {
    this.PanelObserver.setRoomGroupCategoryFilterId(null);
    this.PanelObserver.setCategoryId(null);
  },

  handleClick: function () {
    this.onClick();
  },

  handleChange: function () {
    this.PanelObserver.setRoomGroupCategoryFilterId(this.roomGroupCategoryFilter.id);
    this.PanelObserver.setCategoryId(this.category.id);
  },

  isRoomGroupCategoryFiltersEmpty: function () {
    return !(this.roomGroupCategoryFilters && this.roomGroupCategoryFilters.length > 1);
  },

  getRoomGroupCategoryFilterNameByLanguage: function (roomGroupCategoryFilterTranslations, language) {
    if (!roomGroupCategoryFilterTranslations) {
      return false;
    }
    var roomGroupCategoryFilterTranslation = roomGroupCategoryFilterTranslations.find(rgcft => rgcft.language.toLowerCase().toString() === language.toLowerCase().toString());
    if (angular.isDefined(roomGroupCategoryFilterTranslation)) {
      return roomGroupCategoryFilterTranslation.name;
    }
    return false;
  },

  setRoomGroupCategoryFilter: function (roomGroupCategoryFilter) {
    this.roomGroupCategoryFilter = roomGroupCategoryFilter;
    this.handleChange();
  },

  findRoomGroupCategoryFilterById: function (roomGroupCategoryFilterId) {
    var roomGroupCategoryFilter = this.roomGroupCategoryFilters.find(function (roomGroupCategoryFilter) {
      return roomGroupCategoryFilter.id === roomGroupCategoryFilterId;
    });
    if (angular.isObject(roomGroupCategoryFilter)) {
      return roomGroupCategoryFilter;
    }
    return this.roomGroupCategoryFilters[0];
  },

  setCategory: function (category) {
    this.category = category;
    this.handleChange();
  },

  findCategoryById: function (categoryId) {
    var category = this.categories.find(function (category) {
      return category.id === categoryId;
    });
    if (angular.isObject(category)) {
      return category;
    }
    return this.categories[0];
  }
};
